module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAi0lEQVR4AWNwL/ChKR44C/5rW+v+17J5CMTb/muYcVPfAi2bzP/atv8h2OYguZbglAAZCPIBzBJyfYJX8r+6lTylloAIki2h2ALCltjOItcCQqnqPamWgAiKLKF6RgMabEGKJWCCcktsMulvAf2DiP6RTNhw+mc0+hcV9C/sCBfX9K5wBr7KHPqtCgCDubKx0V30JwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/welfare/red-arrow.png
// module id = OKAJ
// module chunks = 216